export const AD_STATUS = {
    DRAFT: {
        code: 1,
        label: "Draft",
        color: "#1D1D1D",
        bg: "#F1F1F1"
    },
    PUBLISHED: {
        code: 4,
        label: "Delivering",
        color: "#00D143",
        bg: "#E0FFEA"
    },
    DONE: {
        code: 3,
        label: "Ready",
        color: "#3F86CE",
        bg: "#EAF6FF"
    },
    EXPIRED: {
        code: 5,
        label: "Expired",
        color: "#FAB005",
        bg: "#FFF9DB"
    },
    PAUSED: {
        code: 14,
        label: "Paused",
        color: "#FD7E14",
        bg: "#FFF4E6"
    },
    ARCHIVED: {
        code: null,
        label: "Archive",
        color: "#F03E3E",
        bg: "#FDEDED"
    },
};

// AD-220: where a "Let Us Design It" ad is in the design loop (the API's
// design_request.status). While it is set, the Ad List shows it instead of the ad
// status; a Draft briefing and a booked ad show their ad status as usual.
export const DESIGN_STATUS = {
    IN_DESIGN: {
        code: 'in_design',
        label: "In Design",
        color: "#4C6EF5",
        bg: "#EDF2FF"
    },
    IN_APPROVAL: {
        code: 'in_approval',
        label: "In Approval",
        color: "#3F86CE",
        bg: "#EAF6FF"
    },
    FEEDBACK: {
        code: 'feedback',
        label: "Feedback",
        color: "#FAB005",
        bg: "#FFF9DB"
    },
    // Approved; the customer sets up delivery and targeting next (AD-225).
    APPROVED: {
        code: 'approved',
        label: "Setup Needed",
        color: "#FD7E14",
        bg: "#FFF4E6"
    },
};

// The design statuses in which the ad is the designers' and its owner cannot change it
// (AdStudioDesignRequest::LOCKED_STATUSES).
export const DESIGN_LOCKED_STATUSES = [DESIGN_STATUS.IN_DESIGN.code, DESIGN_STATUS.IN_APPROVAL.code, DESIGN_STATUS.FEEDBACK.code];

// Ad::STATUS_EXTENSION: delivering in the extension window. Shown and filtered as
// "Delivering" (PUBLISHED); it has no badge of its own.
export const AD_STATUS_EXTENSION_CODE = 7;

// Dot colors for the "23 Active" / "17 Paused" header count pills — a
// distinct token set from AD_STATUS's table-badge colors above (per the
// "Ad type container" Figma export).
export const AD_STATUS_COUNT_COLORS = {
    ACTIVE: "#00D143",
    PAUSED: "#FCC419",
};
